import React from 'react';
import IMG from "../../constants/image";
import './style.css';
import StoreForm from "./StoreForm";
import {merchantOnboarding} from "../../network/api";
import {LOCAL_STORAGE_KEY, PATH} from "../../constants";
import {useNavigate} from "react-router-dom";
import merchantStore from "../../store/merchantStore";

const Onboarding = () => {
	const navigate = useNavigate()
	const {getMerchantProfile} = merchantStore() || {};
	
	const onUpdateData = async ({newFormData}) => {
		const res = await merchantOnboarding(newFormData);
		if (res?.success) {
			window.localStorage.setItem(LOCAL_STORAGE_KEY.TOKEN, res?.data?.accessToken || '')
			window.localStorage.setItem(LOCAL_STORAGE_KEY.REFRESH_TOKEN, res?.data?.refreshToken || '')
			navigate(PATH.MANAGING_PRODUCT)
			getMerchantProfile()
		}
	}
	
	return (
		<div className='w-fit bg-[#FAFAFC]'>
			<div className='relative flex gap-[5px] justify-center items-center mb-5 mt-4'>
				<img className='w-6 h-6' src={IMG.icon.storeGreen} alt="storeGreen"/>
				<p className='text-sm md:text-xl font-bold'>Thông tin cửa hàng</p>
			</div>
			<p className='w-full text-center text-sm mb-5 px-3'>
				Hoàn thành bước cập nhật thông tin cửa hàng của bạn là bạn có thể tạo sản phẩm để bán hàng rồi.</p>
			<StoreForm onboarding editing onUpdateData={onUpdateData}/>
			<div
				className='md:hidden gap-2.5 flex flex-col justify-center items-center mt-10 bg-[#197D55] py-3 text-white text-center text-[10px]'>
				<p className=''>© 2024 - Bản quyền thuộc về<br/>CÔNG TY CP THƯƠNG MẠI ĐIỆN TỬ VẬN THÔNG</p>
				<p className=''>Một sản phẩm của FUTA Group</p>
			</div>
		</div>
	);
}

export default Onboarding;
